// extracted by mini-css-extract-plugin
export default {"wrapper":"dOJtji","root":"M9dQ0l","girlIcon":"Ds5uTB","title":"MIFdIw","action":"H0OCPw","buttonsBlock":"u6exqC","addNewProductButton":"sisok7"};